<template>
  <v-col cols="12" sm="6" lg="3">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="text-h6 font-weight-black card-indicador-titulo"> Turmas </v-card-text>

      <v-card-text class="text-h4 font-weight-black card-indicador-valor d-flex align-center py-0">
        {{ qtd ?? 0 }}
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "TurmasCard",
  props: {
    franquiaId: {
      type: Number,
    },
  },
  mounted() {
    this.getQtd(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.getQtd(value);
    },
  },
  data() {
    return {
      loading: true,
      qtd: 0,
    };
  },
  methods: {
    async getQtd(franquiaId) {
      if (!franquiaId) return;
      this.loading = true;
      this.qtd = await this.$services.turmasService.qtd(franquiaId);
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.card-indicador-titulo {
  min-height: 96px;
}

.card-indicador-valor {
  height: 72px;
  white-space: nowrap;
}
</style>
